import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'

const defaultStrings = {
  coolPlaceToRunBusiness: 'Tech City is a super cool place to run a business…',
  eastLondonTechCityContent: `
<p>Exciting things are happening in Silicon Roundabout, hundreds of new companies have been born in the past couple of years, employing thousands of people and generating a sense of community, excitement and entrepreneurship in the area.</p> 
<p>The area has proved a profitable place to invest with a number of high profile buy-outs, and even attracted Google and Microsoft to set up business in the area.</p>`,
  europesAnswer: 'Europe’s answer to Silicon Valley',
  europesAnswerDescription: `Following the launch of the government’s “East London Tech City” initiative, Silicon Roundabout’s profile is rising globally. Silicon Roundabout is fast becoming Europe’s answer to Silicon Valley in the area of London encompassing Shoreditch, Hoxton and Old Street. Hoxton Mix offices are strategically located in the heart of Silicon roundabout, offering a <a class="text-decoration-none" href="/virtual-office-london-old-street/" target="_blank" rel="noopener noreferrer">London virtual office</a> for a variety of tech-based UK startups`,
  introductionToTechCity:
    'Introduction to <span class="color-pink2">Tech City</span>',
  introductionToTechCityContent:
    'Great bars, cafe’s, restaurants, nightlife and full of creativity and innovation.',
  introductionToTechCityDescription: '1289 companies and counting…',
  seoDescription:
    "Silicon Roundabout is fast becoming Europe's answer to Silicon Valley in the area of London encompassing Shoreditch, Hoxton and Old Street.",
  seoTitle: "Silicon Roundabout - London's technology hub | Hoxton Mix",
}
export const siliconRoundaboutStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
